import { PhysXObject } from "./PhysXObject";
import * as THREE from "three";
import { PhysXScene } from "./PhysXScene";

export class PhysXActor {
  public obj: THREE.Object3D;
  constructor(public object: PhysXObject, public scene: PhysXScene){
    this.obj = object.obj!;
  }
  public render(delta:number) {}
}
